<template>
  <confirm-dialogs></confirm-dialogs>
  <PVConfirmDialog class="max-w-xl" />

  <Notivue v-slot="item" class="ml-12!">
    <Notification :theme="(themeStore.isDark ? darkTheme : undefined)" :item="item" class="rounded-md">
        <NotificationProgress :item="item" />
    </Notification>
  </Notivue>

  <SGlobalNotification />
  <AssinaturaBloqueadaModal />

  <router-view :key="routerViewKey" />
</template>

<script setup>
import ConfirmDialogs from './components/globals/ConfirmDialogs.vue'
import SGlobalNotification from './components/globals/SGlobalNotification/SGlobalNotification.vue'
import AssinaturaBloqueadaModal from './components/views/assinaturas/AssinaturaBloqueadaModal.vue'
import 'notivue/notification-progress.css'
import { darkTheme, Notification, Notivue, NotificationProgress } from 'notivue'
import { computed, inject, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useTheme } from 'vuetify'
import { useThemeStore } from '@/stores/components/themeStore'
import { storeToRefs } from 'pinia'
import { useSessionStore } from '@/stores/components/sessionStore.js'
import { useRoute } from 'vue-router'

const themeStore = useThemeStore()
const sessionStore = useSessionStore()
const route = useRoute()

// const isLoading = ref(!!sessionStore.userData)

const { isDark } = storeToRefs(themeStore)
const { global } = useTheme()
const websocket = inject('websocket')
const companyRefreshVersion = ref(0)

const routerViewKey = computed(() => {
  return `${route.fullPath}::${companyRefreshVersion.value}`
})

watch(
  () => sessionStore.currentEmpresa?.uuid_emp_id,
  (newEmpresaUuid, oldEmpresaUuid) => {
    if (
      typeof oldEmpresaUuid === 'string' &&
      oldEmpresaUuid &&
      typeof newEmpresaUuid === 'string' &&
      newEmpresaUuid &&
      oldEmpresaUuid !== newEmpresaUuid
    ) {
      companyRefreshVersion.value += 1
    }
  }
)

onMounted(async () => {
  await sessionStore.initialize()

  if (sessionStore.isAuthenticated) {
    websocket.connectWebSocket()
  }

  // if (!sessionStore.isAuthenticated) {
  //   window.location.replace('/login')
  // }

  updateHtmlClass(isDark.value)

  watch(isDark, (newValue) => {
    updateHtmlClass(newValue)
  })

  // window.addEventListener('storage', handleStorageThemeChange)
})

onBeforeUnmount(() => {
  // window.removeEventListener('storage', handleStorageThemeChange)
})

function handleStorageThemeChange(event) {
  if (event.key === 'darkTheme') {
    const isDark = event.newValue === 'true'
    themeStore.setDarkMode(isDark)
    global.name.value = isDark ? 'dark' : 'light'
  }
}

function updateHtmlClass(isDark) {
  const html = document.documentElement

  html.classList.toggle('dark', isDark)
  html.classList.toggle('light-theme-scroll', !isDark)
  html.classList.toggle('dark-theme-scroll', isDark)

  global.name.value = isDark ? 'dark' : 'light'
}
</script>
